import _ from "lodash";
import { APP_IDENTITY } from "config/app";

export function isValidString(str: unknown): boolean {
  // Check if the string is not null or undefined
  if (_.isNil(str) || !_.isString(str)) {
    return false;
  }

  // Trim the string and then check if it's empty
  return !_.isEmpty(_.trim(str));
}

export function setTabTitle(title: string | null | undefined): void {
  if (!title) {
    document.title = APP_IDENTITY.name;
  } else {
    document.title = `${title} - ${APP_IDENTITY.name}`;
  }
}
